import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import { formatMobilePhone } from "utils"
import classes from "./OhCustomerInfo.module.scss"

const OhCustomerInfo = props => {
  const { order } = props

  const [t] = useTranslation()

  const systemIsActivated =
    useSelector(state => state.systemSettings.systemIsActivated)

  return (
    <Fragment>
      <div className={classes["delivery-address"]}>
        <span className={classes["title"]}>
          {t("جزئیات_مشتری")} {order.isGuestOrder ? `(${t("کاربر_مهمان")})` : ""}
        </span>
        <div className="mb-1">
          {t("نام")}: <b>{systemIsActivated ? order.customerFullName : "************"}</b>
        </div>

        <div className={classes["phone-number"]}>
          {t("موبایل")}:{" "}
          <b>
            {systemIsActivated ? formatMobilePhone(order.customerMobilePhone) : "************"}
          </b>
        </div>
      </div>

      {
        order.addedBySystem &&
        <div className={classes["delivery-address"]}>
          <div className={classes["title"]}>
            {t("طریق_سفارش")}
          </div>
          <div className={classes["row"]}>
            <span>{t("نام")}:{" "}</span>
            <b>{order.addedByFullName}</b>
          </div>
        </div>
      }
    </Fragment>
  )
}

export default OhCustomerInfo